import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';

const useStyles = makeStyles((theme) => ({
  root: { paddingTop: theme.spacing(1), maxWidth: 800 },
  header: {
    marginBottom: theme.spacing(1),
    fontWeight: 'bold',
    marginLeft: 'auto',
    marginRight: 'auto',
    [theme.breakpoints.down('sm')]: {
      marginTop: 0,
    },
  },
  subtitle: {
    fontSize: '1.4em',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));

export default function Header(props) {
  const classes = useStyles();

  const { header, subtitle, customSubtitle, children } = props;

  return (
    <Container className={classes.root}>
      <Typography variant="h4" align="center" className={classes.header}>
        {header}
        {children}
      </Typography>
      {subtitle && (
        <Typography align="center" className={classes.subtitle}>
          {subtitle}
        </Typography>
      )}
      {customSubtitle}
    </Container>
  );
}
